import {AuditedSerializable, ISerializable} from './base';
import * as moment from 'moment';

export class Template extends AuditedSerializable<Template> {

    static EMPTY: Template = new Template();
    name: string | undefined;
    code: string | undefined;
    flute: string | undefined;
    bstrength: string | undefined;
    blanklength: number | undefined;
    blankwidth: number | undefined;
    knockdepth: number | undefined;
    knocklength: number | undefined;
    knockwidth: number | undefined;
    length: number | undefined;
    width: number | undefined;
    depth: number | undefined;
    reqby: string | undefined;
    check1: boolean | undefined;
    check2: boolean | undefined;
    check5: boolean | undefined;
    check6: boolean | undefined;
    check7: boolean | undefined;
    check8: boolean | undefined;
    pdf: boolean | undefined;
    check9: boolean | undefined;
    check10: boolean | undefined;
    image: any | undefined;
    pgroup: any | undefined;
    q1: number | undefined;
    privateGrp: string | undefined;
    p1: number | undefined;
    q2: number | undefined;
    q3: number | undefined;
    q4: number | undefined;
    q5: number | undefined;
    q6: number | undefined;
    q7: number | undefined;
    q8: number | undefined;
    q9: number | undefined;
    q10: number | undefined;
    q11: number | undefined;
    q12: number | undefined;
    q13: number | undefined;
    q14: number | undefined;
    q15: number | undefined;
    q16: number | undefined;
    q17: number | undefined;
    q18: number | undefined;
    q19: number | undefined;
    q20: number | undefined;
    p2: number | undefined;
    p3: number | undefined;
    p4: number | undefined;
    p5: number | undefined;
    p6: number | undefined;
    p7: number | undefined;
    p8: number | undefined;
    p9: number | undefined;
    p10: number | undefined;
    p11: number | undefined;
    p12: number | undefined;
    p13: number | undefined;
    p14: number | undefined;
    p15: number | undefined;
    p16: number | undefined;
    p17: number | undefined;
    p18: number | undefined;
    p19: number | undefined;
    p20: number | undefined;
    email: string | undefined;
    fname: string | undefined;
    lname: string | undefined;
    createdDate: Date | undefined;
    portalcode: string | undefined;
    status: Boolean | undefined;

    override deserialize(input: any): Template {
        super.deserialize(input);
        this.name = input.name;
        this.code = input.code;
        this.flute = input.flute;
        this.bstrength = input.bstrength;
        this.length = input.length;
        this.width = input.width;
        this.depth = input.depth;
        this.check1 = input.check1;
        this.reqby = input.reqby;
        this.portalcode = input.portalcode;
        this.blanklength = input.blanklength;
        this.blankwidth = input.blankwidth;
        this.knockdepth = input.knockdepth;
        this.knocklength = input.knocklength;
        this.knockwidth = input.knockwidth;
        this.lname = input.lname;

        this.fname = input.fname;
        this.status = input.status;
        this.email = input.email;
        this.check2 = input.check2;
        this.check5 =input.check5;
        this.privateGrp=input.privateGrp;
        this.check6 = input.check6;
        this.check7 = input.check7;
        this.check8 =input.check8;
        this.pdf =input.pdf;

        this.check9 = input.check9;
        this.check10 = input.check10;
        this.pgroup = input.pgroup;
        this.image = input.image;
        this.q1 = input.q1;
        this.p1 = input.p1;
        this.q2 = input.q2;
        this.p2 = input.p2;
        this.q3 =input.q3;
        this.p3 = input.p3;
        this.q4 = input.q4;
        this.p4 = input.p4;
        this.q5 = input.q5;
        this.p5 = input.p5;
        this.q6 =input.q6;
        this.p6 = input.p6;
        this.q7 = input.q7;
        this.p7 =input.p7;
        this.q8 = input.q8;
        this.p8 = input.p8;
        this.q9 =input.q9;
        this.p9 = input.p9;
        this.q10 = input.q10;
        this.p10 = input.p10;
        this.q11 = input.q11;
        this.p11 = input.p11;
        this.q12=input.q12;
        this.p12 = input.p12;
        this.q13 = input.q13;
        this.p13 = input.p13;
        this.q14=input.q14;
        this.p14 = input.p14;
        this.q15 = input.q15;
        this.p15 = input.p15;
        this.q16 = input.q16;
        this.p16 = input.p16;
        this.q17=input.q17;
        this.p17 = input.p17;
        this.q18 = input.q18;
        this.p18 = input.p18;
        this.q19=input.q19;
        this.p19 = input.p19;
        this.q20=input.q20;
        this.p20 = input.p20;
        this.createdDate=input.createdDate;

        this.image='data:image/jpeg;base64,'+input.image;
        return this;

    }

  
}

